import { Tooltip } from '@pique/component/ui/tooltip';
import { useCatchEventCallback } from '@pique/core/hooks/use-catch-event-hook';
import { SubscriptionPlan } from '@pique/graphql';
import { useI18n } from '@pique/i18n';
import { useLiveData, useServices } from '@toeverything/infra';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { openSettingModalAtom } from '../../../atoms';
import {
  ServerConfigService,
  SubscriptionService,
} from '../../../modules/cloud';
import * as styles from './style.css';

export const UserPlanButton = () => {
  const { serverConfigService, subscriptionService } = useServices({
    ServerConfigService,
    SubscriptionService,
  });

  const hasPayment = useLiveData(
    serverConfigService.serverConfig.features$.map(
      (r: Record<string, boolean | undefined> | null) => r?.['payment']
    )
  );
  const plan = useLiveData(
    subscriptionService.subscription.pro$.map(
      (subscription: { plan: string } | null | undefined) =>
        subscription !== null ? subscription?.plan : null
    )
  );
  const isLoading = plan === null;

  useEffect(() => {
    // revalidate subscription to get the latest status
    subscriptionService.subscription.revalidate();
  }, [subscriptionService]);

  const setSettingModalAtom = useSetAtom(openSettingModalAtom);
  const handleClick = useCatchEventCallback(() => {
    setSettingModalAtom({
      open: true,
      activeTab: 'plans',
      scrollAnchor: 'cloudPricingPlan',
    });
  }, [setSettingModalAtom]);

  const t = useI18n();

  if (!hasPayment) {
    // no payment feature
    return;
  }

  if (isLoading) {
    // loading, do nothing
    return;
  }

  const planLabel = plan ?? SubscriptionPlan.Free;

  return (
    <Tooltip content={t['com.pique.plans.tooltip']()} side="top">
      <div
        className={styles.userPlanButton}
        onClick={handleClick}
        data-event-props="$.settingsPanel.profileAndBadge.viewPlans"
      >
        {planLabel}
      </div>
    </Tooltip>
  );
};
